import { useMediaQuery } from './use-media-query';

export function useIsDesktop(): boolean {
  return useMediaQuery('(min-width: 768px)');
}
